
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nft/covers",
      function () {
        return require("private-next-pages/nft/covers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nft/covers"])
      });
    }
  